<template>
  <div id="page-settings-sync">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="12">
        <h2 class="breadcrumb">Παράμετροι XML</h2>
        <p>
          Συνδέστε το αρχείο <strong>XML</strong> που θα περιέχει το σύνολο των προϊόντων σας.
        </p>
      </vs-col>
    </vs-row>

    <div class="vx-card p-6">

      <!-- Content Row -->
      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <div class="flex items-end mb-3">
            <feather-icon icon="FileIcon" class="mr-2" svgClasses="w-5 h-5"/>
            <h4 class="leading-none font-medium text-primary">Διεύθυνση URL αρχείου XML</h4>
          </div>
          <p>
            Κάντε επικόλληση του url στα παρακάτω πεδίο.
          </p>

          <vs-divider/>

          <div class="vx-row mt-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Url (.xml format)</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <vs-input type="url" class="w-full" icon-pack="feather" icon="icon-link" icon-no-border
                        v-model="item.url"/>
            </div>
          </div>

          <div style="display: none;" class="vx-row mt-6 excel-import">
            <div class="vx-col w-full">
              <input type="file" ref="fileInput" class="hidden" accept=".xlsx, .xls"
                     @change="handleClick">
              <div
                  @click="$refs.fileInput.click()"
                  @drop="handleDrop"
                  @dragover="handleDragover"
                  @dragenter="handleDragover"
                  class="px-8 py-16 cursor-pointer text-center border-2 border-dashed d-theme-border-grey-light d-theme-dark-bg text-xl">
                <feather-icon icon="UploadCloudIcon" svgClasses="h-16 w-16 stroke-current text-grey"
                              class="block"/>
                <span>Αποθέστε το αρχείο ή κάντε </span>
                <span class="font-medium text-primary"
                      @click.stop="$refs.fileInput.click()">Αναζήτηση</span>
                <!-- <vs-button type="border" @click.stop="$refs.fileInput.click()">Browse</vs-button> -->
              </div>
            </div>
          </div>

        </div>

        <div class="vx-col md:w-1/2 w-full mt-20 md:mt-0">

          <div class="flex items-end mb-3">
            <feather-icon icon="FileIcon" class="mr-2" svgClasses="w-5 h-5"/>
            <h4 class="leading-none font-medium text-primary">Αντιστοίχηση πεδίων XML</h4>
          </div>
          <p>Αντιστοιχίστε το όνομα των πεδίων από το XML.</p>

          <vs-divider/>

          <div class="vx-row">
            <div class="vx-col sm:w-1/2 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>UID</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.uid"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>MPN</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.mpn"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>NAME</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.name"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>LINK</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.link"/>
                </div>
              </div>
            </div>

            <div class="vx-col sm:w-1/2 w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>IMAGE</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.image"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>CATEGORY</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.category"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>PRICE</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.price"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>MAN/RER</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.manufacturer"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>DISCOUNT</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.discount"/>
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>GROUP</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="item.group"/>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Save & Reset Button -->

      <!--  <div class="vx-row" v-if="!validateForm()" >
            <vs-alert class="mt-5" >Παρακαλώ συμπληρώστε όλα τα πεδία XML, καθώς και ένα από τα URL ή Αρχείο XLSX.</vs-alert>
        </div>-->
      <!-- start::row -->
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <div class="mt-8 flex flex-wrap items-center">
            <vs-button style="display:none;" class="mt-2 vs-button-warning vs-button-border" @click="syncLinks()">
              Εισαγωγή συνδέσμων (πηγών)
            </vs-button>
            <vs-button v-if="item && item.url" class="mt-2 ml-2 vs-button-danger vs-button-border" @click="deleteAllProducts">
              Εκκαθάριση προϊοντων
            </vs-button>
            <vs-button v-if="item && item.url" @click="updateProducts" color="warning" type="filled" icon="update" class="ml-2 mt-2">
              Άυτόματη  Ανανέωση στοιχείων<sup>*</sup>
            </vs-button>
          </div>
        </div>
        <div class="vx-col w-1/2">
          <div class="mt-8 flex flex-wrap items-center justify-end">
            <vs-button class="ml-auto mt-2" @click="openConfirm()">Αποθήκευση</vs-button>
          </div>
        </div>
      </div>
      <!-- end::row -->

      <!-- start::row -->
      <div class="vx-row">
        <div v-if="item && item.url" class="vx-col pt-2">
          <p>*: Αν επιθυμείτε άμεση/αυτόματη  ανανέωση των στοιχείων λόγω μεταβολών στο xml  πιέστε αποδοχή.</p>
        </div>
      </div>
      <!-- end::row -->

    </div>
    <!--Start: Έλεγχος 2 -->
    <div style="display: none;" class="vx-card p-6 mt-10">

      <div class="vx-row">
        <div class="vx-col md:w-1/2 w-full">
          <div class="flex items-end mb-3">
            <feather-icon icon="ClockIcon" class="mr-2" svgClasses="w-5 h-5"/>
            <h4 class="leading-none font-medium text-primary">Έλεγχος τιμών</h4>
          </div>
          <p>Επιλέξτε από τις προκαθορισμένες τιμές ή φτιάξτε το δικό σας πρόγραμμα</p>

          <vs-divider/>

          <div class="vx-row mt-6">
            <div class="vx-col sm:w-1/3 w-full">
              <span>Προκαθορισμένοι έλεγχοι</span>
            </div>
            <div class="vx-col sm:w-2/3 w-full">
              <v-select :clearable="false" v-model="prokat" name="excecute-int"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :options="['Κάθε 6 ώρες','Κάθε 8 ώρες','Κάθε 12 ώρες','Κάθε μέρα στις 6 π.μ.','Κάθε Δευτέρα στις 6 π.μ.']"/>
            </div>
          </div>

          <vs-divider/>

          <div class="vx-row mt-6">
            <div class="vx-col w-1/2">
              <vs-col class="sm:w-3/3 w-full mb-2" vs-type="flex" vs-justify="space-between">
                <span>Ώρες*</span>
                <vs-button
                    @click="schedule.hours = ['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23']"
                    type="flat">Επιλογή Όλων
                </vs-button>
              </vs-col>
              <vs-col class="vx-col sm:w-3/3 w-full">
                <v-select multiple :clearable="false" v-model="schedule.hours"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          :options="['00','01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23']"/>
              </vs-col>
            </div>
            <div class="vx-col w-1/2">
              <vs-col class="sm:w-3/3 w-full mb-2" vs-type="flex" vs-justify="space-between">
                <span>Ημέρες του μήνα*</span>
                <vs-button
                    @click="schedule.monthDays = ['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31']"
                    type="flat">Επιλογή Όλων
                </vs-button>
              </vs-col>
              <vs-col class="sm:w-3/3 w-full">
                <v-select :clearable="false" multiple v-model="schedule.monthDays" name="excecute-int"
                          :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          :options="['01','02','03','04','05','06','07','08','09','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31']"/>
              </vs-col>
            </div>
          </div>

          <vs-row class="mt-3">
            <vs-col class="sm:w-3/3 w-full mb-2" vs-type="flex" vs-justify="space-between">
              <span>Ημέρες της Εβδομάδας*</span>
              <vs-button
                  @click="schedule.weekDays = ['Δευτέρα','Τρίτη','Τετάρτη','Πέμπτη','Παρασκευή','Σάββατο','Κυριακή']"
                  type="flat">Επιλογή Όλων
              </vs-button>

            </vs-col>
            <vs-col class="sm:w-3/3 w-full">
              <v-select multiple :clearable="false" v-model="schedule.weekDays" name="excecute-int"
                        :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :options="['Δευτέρα','Τρίτη','Τετάρτη','Πέμπτη','Παρασκευή','Σάββατο','Κυριακή']"/>
            </vs-col>
          </vs-row>

          <div class="vx-row mt-3 mb-12">
            <div class="vx-col sm:w-3/3 w-full">
              <span>Φιλική ονομασία Cron*</span>
              <vs-input class="w-full" v-model="schedule.label"/>
            </div>
          </div>

          <!--  <div class="vx-row" v-if="!validateSyncForm()" >
                <vs-alert class="mt-5" >Παρακαλώ συμπληρώστε όλα τα πεδία</vs-alert>
            </div>-->

          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="formCron()">Προσθήκη</vs-button>
              </div>
            </div>
          </div>

        </div>

        <div class="vx-col md:w-1/2 w-full mt-20 md:mt-0">

          <vs-list>
            <vs-list-header title="Αποθηκευμένοι έλεγχοι" color="warning"></vs-list-header>

            <vs-list-item v-for="sch in schedules" :key="sch.id" :title="sch.label">
              <vs-button color="danger" type="border" @click="deleteSchedule(sch.id)" icon-pack="feather"
                         icon="icon-trash" size="small"></vs-button>
            </vs-list-item>

          </vs-list>

        </div>
      </div>
    </div>
    <!--End:  Έλεγχος 2-->
  </div>
</template>

<script>
import vSelect from 'vue-select'
import XLSX from 'xlsx'
import axios from '@/axios.js'

export default {
  props: {
    // onSuccess: {
    //   type: Function,
    //   required: true
    // }
  },
  components: {
    vSelect,
  },

  data() {
    return {
      item: {
        "url": "",
        "uid": "",
        "mpn": "",
        "name": "",
        "link": "",
        "price": "",
        "manufacturer": "",
        "image": "",
        "category": "",
        "file": null,
        "group": "",
        "discount": ""
      },
      xfilename: '',
      schedule: {
        label: '',
        hours: [],
        monthDays: [],
        weekDays: [],
      },
      schedules: [],
      prokat: null,
      apiEndpoint: localStorage.getItem('apiEndpoint'),
      token: localStorage.getItem('accessToken'),
      initiated: false,
      initiatedSync: false,
      excelData: {
        header: null,
        results: null,
        meta: null
      }
    }
  },
  watch: {
    prokat: function (val) {
      let vm = this;
      vm.schedule.label = val;
      vm.schedule.hours = [];
      vm.schedule.monthDays = [];
      vm.schedule.weekDays = [];
      if (val == 'Κάθε μέρα στις 6 π.μ.') {
        vm.schedule.hours = ['06'];
        vm.schedule.monthDays = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
        vm.schedule.weekDays = ['Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή'];
      }
      if (val == 'Κάθε 6 ώρες') {
        vm.schedule.hours = ['00', '06', '12', '18'];
        vm.schedule.monthDays = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
        vm.schedule.weekDays = ['Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή'];
      }
      if (val == 'Κάθε 8 ώρες') {
        vm.schedule.hours = ['00', '08', '16'];
        vm.schedule.monthDays = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
        vm.schedule.weekDays = ['Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή'];
      }
      if (val == 'Κάθε 12 ώρες') {
        vm.schedule.hours = ['00', '12'];
        vm.schedule.monthDays = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
        vm.schedule.weekDays = ['Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο', 'Κυριακή'];
      }
      if (val == 'Κάθε Δευτέρα στις 6 π.μ.') {
        vm.schedule.hours = ['06'];
        vm.schedule.monthDays = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
        vm.schedule.weekDays = ['Δευτέρα'];
      }
    }
  },
  methods: {
    updateProducts() {
      this.$vs.dialog({
        color: 'primary',
        title: `Ενημέρωση των προϊόντων`,
        text: `Θα γίνει ενημέρωση προϊόντων και τιμών από το αρχείο xml. Για αποδοχή της διαδικασίας κάντε κλικ στο
        κουμπί αποδοχή για ακύρωση κάντε κλικ στο Χ. Η διάρκεια της διαδικασίας είναι από 1 έως 3 λεπτά και είναι
        ανάλογη προς το πλήθος των προϊόντων σας`,
        acceptText: 'αποδοχή',
        accept: this.acceptAlert,
      })
    },
    acceptAlert() {
      this.$vs.loading()
      this.$store.dispatch('xmlUpdate').then((response) => {
        if (response.error === false) {
          this.$vs.notify({
            color: 'success',
            title: 'Επιτυχία',
            position: 'top-right',
            text: 'Η ενημέρωση έγινε.',
          })

          this.$vs.loading.close()
        } else {
          this.$vs.notify({
            color: 'error',
            title: 'Αποτυχία',
            position: 'top-right',
            text: 'Η ενημέρωση δεν έγινε',
          })
          this.$vs.loading.close()
        }
      })
    },
    validateSyncForm() {
      let vm = this;
      if ((!vm.schedule.label || !vm.schedule.weekDays.length || !vm.schedule.monthDays.length || !vm.schedule.hours.length) && vm.initiatedSync) {
        return false;
      }
      return true;
    },
    validateForm() {
      let vm = this;
      if ((!vm.item.uid || !vm.item.mpn || !vm.item.name || !vm.item.link || !vm.item.image || !vm.item.category || !vm.item.price || !vm.item.manufacturer
          // || (!vm.item.url && !vm.xfilename)
      ) && vm.initiated) {
        return false;
      }
      return true;
    },
    generateData({header, results, meta}) {
      this.excelData.header = header
      this.excelData.results = results
      this.excelData.meta = meta
      // if (this.onSuccess) this.onSuccess(this.excelData)
    },
    getHeaderRow(sheet) {
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C = undefined
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({c: C, r: R})]
        /* find the cell in the first row */
        let hdr = `UNKNOWN ${C}` // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
    },
    handleDragover(e) {
      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
    },
    handleDrop(e) {
      e.stopPropagation()
      e.preventDefault()
      const files = e.dataTransfer.files
      if (files.length !== 1) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only support uploading one file!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return
      }
      const rawFile = files[0] // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$vs.notify({
          title: 'Login Attempt',
          text: 'Only supports upload .xlsx, .xls, .csv suffix files',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
        return false
      }
      this.uploadFile(rawFile)
    },
    removeTrailingZeros(val) {
      val = val.replace('00', '0');
      val = val.replace('01', '1');
      val = val.replace('02', '2');
      val = val.replace('03', '3');
      val = val.replace('04', '4');
      val = val.replace('05', '5');
      val = val.replace('06', '6');
      val = val.replace('07', '7');
      val = val.replace('08', '8');
      val = val.replace('09', '9');
      return val;
    },
    readerData(rawFile) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, {type: 'array'})
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          const meta = {sheetName: firstSheetName}
          this.generateData({header, results, meta})
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
    },
    handleClick(e) {
      const files = e.target.files
      const rawFile = files[0]
      if (!rawFile) return
      // console.log(rawFile);
      this.uploadFile(rawFile)
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name)
    },
    uploadFile(file) {
      this.$refs['fileInput'].value = null // fix can't select the same excel
      this.item.file = file;
      this.xfilename = this.item.file.name;

      // console.log(this.item.file.name);

      // this.readerData(file)
    },
    getSettings() {
      let vm = this;
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.get('xmlOptions/list')
          .then((response) => {
            vm.item = response.data;
            if (vm.item.url === "null") {
              vm.item.url = '';
            }
            vm.getSchedules();
          })
          .catch((error) => {
            vm.$vs.loading.close();
          })
    },
    getSchedules() {
      let vm = this;
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.get('schedules/list')
          .then((response) => {
            vm.schedules = response.data;
            vm.$vs.loading.close();
          })
          .catch((error) => {
            vm.$vs.loading.close();
          })
    },
    deleteSchedule(scheduleId) {
      let vm = this;
      vm.$vs.loading();
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.delete('schedules/delete/' + scheduleId)
          .then((response) => {
            vm.$vs.notify({
              color: 'success',
              title: 'Επιτυχία',
              position: 'top-right',
              text: 'Οι αλλαγές σας αποθηκεύτηκαν.'
            });
            vm.getSchedules();
            vm.$vs.loading.close();
          })
          .catch((error) => {
            vm.$vs.loading.close();
          })
    },
    formCron() {
      let vm = this;

      // VALIDATION SECTION
      this.initiatedSync = true;
      if (!vm.validateSyncForm()) {
        vm.$vs.notify({
          color: 'danger',
          title: 'Λάθος στον έλέγχο πεδίων',
          position: 'top-right',
          text: 'Παρακαλώ συμπληρώστε όλα τα πεδία με *.'
        })
        return;
      }

      let _hours = vm.removeTrailingZeros(vm.schedule.hours.length ? vm.schedule.hours.join() : '*');
      let _monthDays = vm.removeTrailingZeros(vm.schedule.monthDays.length ? vm.schedule.monthDays.join() : '*');


      let _weekDays = vm.schedule.weekDays ? vm.schedule.weekDays.join() : '*';
      _weekDays = _weekDays.replace('Δευτέρα', '1');
      _weekDays = _weekDays.replace('Τρίτη', '2');
      _weekDays = _weekDays.replace('Τετάρτη', '3');
      _weekDays = _weekDays.replace('Πέμπτη', '4');
      _weekDays = _weekDays.replace('Παρασκευή', '5');
      _weekDays = _weekDays.replace('Σάββατο', '6');
      _weekDays = _weekDays.replace('Κυριακή', '0');
      let cronjob = '0 ' + _hours + ' ' + _monthDays + ' * ' + _weekDays;

      // console.log(vm.removeTrailingZeros(cronjob))
      vm.$vs.loading();

      let scheduleObj = {
        'label': vm.schedule.label,
        'cron': cronjob,
        'hour': _hours,
        'dayOfMonth': _monthDays,
        'dayOfWeek': _weekDays
      }
      axios.post("schedules/add", scheduleObj)
          .then((response) => {
            vm.schedule = {
              label: '',
              hours: [],
              monthDays: [],
              weekDays: [],
            };
            vm.initiatedSync = false;
            vm.$vs.notify({
              color: 'success',
              title: 'Επιτυχία',
              position: 'top-right',
              text: 'Οι αλλαγές σας αποθηκεύτηκαν.'
            });
            vm.getSchedules();
          })
          .catch((error) => {
            vm.$vs.loading.close();
          })


    },
    openConfirm() {
      let vm = this;
      if (!vm.item.url && !vm.xfilename) {
        this.saveSettings();
      } else {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Επιβεβαίωση`,
          acceptText: 'Αποδέχομαι',
          cancelText: 'Ακύρωση',
          text: 'Με την κίνηση αυτή θα σβηστούν όλα τα προϊόντα και θα ξαναπεραστούν από την πηγή που ορίσατε. Είστε σίγουρος;',
          accept: this.saveSettings
        })
      }
    },
    deleteAllProducts() {
      let vm = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Επιβεβαίωση`,
        text: 'Με την κίνηση αυτή θα σβηστούν όλα τα προϊόντα. Είστε σίγουρος;',
        acceptText: 'Διαγραφή',
        cancelText: 'Ακύρωση',
        accept: this.deleteAllProductAction
      })
    },
    deleteAllProductAction() {
      let vm = this;
      vm.$vs.loading();
      axios.defaults.baseURL = vm.apiEndpoint;
      axios.defaults.headers.common = {'Authorization': `bearer ${vm.token}`}
      axios.delete('products/delete-all')
          .then((response) => {
            vm.$vs.notify({
              color: 'success',
              title: 'Επιτυχία',
              position: 'top-right',
              text: 'Τα προϊόντα διαγράφηκαν με επιτυχία.'
            });
            vm.$vs.loading.close();
          })
          .catch((error) => {
            vm.$vs.notify({
              color: 'danger',
              title: 'Αποτυχία',
              position: 'top-right',
              text: 'Τα προϊόντα δεν διαγράφηκαν με επιτυχία.'
            });
            vm.$vs.loading.close();
          })
    },
    syncLinks() {
      let vm = this;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Επιβεβαίωση`,
        text: 'Θα μεταφερθείτε σε περιβάλλον εισαγωγή νέων συνδέσμων για το skroutz από excel. Είστε σίγουρος;',
        acceptText: 'Άνοιγμα',
        cancelText: 'Ακύρωση',
        accept: this.syncLinksAction
      })
    },
    syncLinksAction() {
      window.location.href = "/settings/importlinks";
    },
    saveSettings() {
      {
        let vm = this;

        // VALIDATION SECTION
        this.initiated = true;
        if (!vm.validateForm()) {
          vm.$vs.notify({
            color: 'danger',
            title: 'Λάθος στον έλέγχο πεδίων',
            position: 'top-right',
            text: 'Παρακαλώ συμπληρώστε όλα τα πεδία με XML.'
          })
          return;
        }

        const formData = new FormData();
        vm.$vs.loading();
        // console.log('sending...');
        // console.log(vm.item.file);
        formData.append('url', vm.item.url);
        formData.append('uid', vm.item.uid);
        formData.append('mpn', vm.item.mpn);
        formData.append('name', vm.item.name);
        formData.append('link', vm.item.link);
        formData.append('price', vm.item.price);
        formData.append('manufacturer', vm.item.manufacturer);
        formData.append('image', vm.item.image);
        formData.append('category', vm.item.category);
        formData.append('file', vm.item.file);
        axios.post("xmlOptions/update", formData)
            .then((response) => {
              vm.$vs.loading.close();
              vm.initiated = false;
              vm.$vs.notify({
                color: 'success',
                title: 'Οι αλλαγές αποθηκεύτικαν με επιτυχία',
                position: 'top-right',
                text: response.data.message //'The selected source configuration was successfully saved and new products have been parsed.'
              })
            })
            .catch((error) => {
              vm.$vs.loading.close();
              vm.$vs.notify({
                color: 'warning',
                title: 'Οι αλλαγές δεν αποθηκεύτικαν με επιτυχία',
                position: 'top-right',
                text: 'Παρουσιάστηκε κάποιο σφάλμα και δεν ήταν δυνατή η ανάλυση της πηγής. Ελέγξτε ότι όλα τα πεδία έχουν ρυθμιστεί σωστά με επικεφαλίδες.'
              })
            })
      }
    }

  },
  mounted() {
    let vm = this;
    vm.$vs.loading();
    vm.getSettings();
  }
}
</script>

<style scoped>
.vs-button-primary.vs-button-flat {
  font-size: 9px;
  padding: 5px !important;
}
</style>
